import React from 'react';
import { AgGridReactProps } from 'ag-grid-react';

export type withClientSideGridProps = {
  gridConfig: AgGridReactProps;
};

export type withClientSideGridOutput = {
  gridConfig?: AgGridReactProps;
};

//NOTE: This is the interface to translate different proops to agGridProps
// such as data: T[], columns, etc.
// could include generics to allow for different types of data
export function withClientSideGrid(WrappedComponent: React.ComponentType<any>) {
  return function withAgGrid(props: withClientSideGridProps) {
    return <WrappedComponent {...props} />;
  };
}
